import { createNavigation } from 'next-intl/navigation';

export const accountPathnames = {
  '/account': '/account',
  '/account/orders': '/account/orders',
  '/account/bookings': '/account/bookings',
  '/account/subscription': '/account/subscription',
  '/account/subscription/payments': '/account/subscription/payments',
  '/account/subscription/cancel': '/account/subscription/cancel',
  '/account/subscription/redeem': '/account/subscription/redeem',
  '/account/profile': '/account/profile',
  '/account/signin': '/account/signin',
  '/account/signup': '/account/signup',
  '/account/lookup': '/account/lookup',
  '/account/reset-password': '/account/reset-password',
  '/account/set-password': '/account/set-password',
};

const { Link, redirect, usePathname, useRouter, getPathname } =
  createNavigation();

export { getPathname, Link, redirect, usePathname, useRouter };
